import React, { useContext } from 'react';
import localize from '../i18n/localize';
import LocalizedContext from '../i18n/LocalizedContext';

import './LanguageSelector.css';
import '../styles/colors.css';

const LanguageSelector = props => {
    const langPack = props.langPack;
    const language = props.language;
    const langHandler = props.setLangHandler;
    const currentMode = props.mode;
    const setModeHandler = props.setModeHandler;

    const lang = useContext(LocalizedContext);


    const langs = langPack.map( data => {
        const clazz = language === data.adjective ? 'LanguageSelector-selected' : 'LanguageSelector';
        const handler = language === data.adjective ? () => {} : () => { langHandler(data.adjective) };

        return(<span
                key={data.adjective}
                className={clazz}
                onClick={handler}>{data.feName}</span>)
    });

    const mode = ['general', 'personal'].map( data => {
        const clazz = currentMode === data ? 'LanguageSelector-selected' : 'LanguageSelector';
        const handler = currentMode === data ? () => {} : () => { setModeHandler(data) };

        return(<span key={data}
                     className={clazz}
                     onClick={handler}>{localize(lang, data)}</span>)
    });

    return (
        <div className='LanguageSelector-container'>
            <div className='LanguageSelector-left'>
                {mode}
            </div>
            <div className='LanguageSelector-right'>
                {langs}
            </div>
        </div>
    );
}

export default LanguageSelector;